import React from "react";
import Navbar from "../../partials/Navber";
import Footer from "../../partials/Footer";
import CartModal from "../../partials/CartModal";

const sections = [
  {
    title: "1. Introdução",
    content: `A Flitz respeita sua privacidade e valoriza a transparência. Esta Política descreve como tratamos seus dados pessoais durante a navegação e uso do nosso site.`,
  },
  {
    title: "2. Informações Coletadas",
    content: `Coletamos informações necessárias para oferecer nossos serviços, como:

• Dados de cadastro: nome, e-mail e senha.
• Endereço de entrega: para envio de pedidos.
• Dados de pagamento: processados com segurança por parceiros especializados.`,
  },
  {
    title: "3. Uso das Informações",
    content: `Utilizamos seus dados para:

• Processar pedidos e entregas.
• Enviar atualizações sobre o status da compra.
• Oferecer suporte e atendimento personalizado.
• Comunicar promoções, se autorizado.`,
  },
  {
    title: "4. Compartilhamento de Dados",
    content: `Nunca vendemos suas informações. Podemos compartilhá-las apenas com:

• Parceiros logísticos e de pagamento.
• Autoridades legais, quando necessário.`,
  },
  {
    title: "5. Segurança da Informação",
    content: `Utilizamos práticas modernas de segurança e criptografia para proteger seus dados. Nosso site conta com proteção SSL e infraestrutura segura.`,
  },
  {
    title: "6. Seus Direitos",
    content: `Você pode acessar, atualizar ou solicitar a exclusão dos seus dados a qualquer momento. Basta entrar em contato conosco.`,
  },
  {
    title: "7. Retenção de Dados",
    content: `Armazenamos seus dados apenas pelo tempo necessário para cumprir obrigações legais e operacionais.`,
  },
  {
    title: "8. Atualizações da Política",
    content: `Esta política pode ser atualizada a qualquer momento. A versão mais recente estará sempre disponível em nosso site.`,
  },
  {
    title: "9. Fale Conosco",
    content: `Dúvidas? Escreva para: contato@flitzbr.com.br — nossa equipe terá prazer em ajudar.`,
  },
];

const Politica = () => {
  return (
    <>
      <Navbar />
      <main className="bg-white text-gray-800 min-h-screen mt-24 px-6 md:px-20 lg:px-40 py-12">
        <h1 className="text-4xl font-semibold mb-12 text-gray-900 text-center">
          Política de Privacidade - Flitz
        </h1>
        <div className="space-y-16">
          {sections.map((section, index) => (
            <section key={index} className="scroll-mt-24 border-b border-gray-200 pb-10">
              <h2 className="text-2xl font-medium text-gray-900 mb-4">{section.title}</h2>
              <p className="text-base leading-relaxed whitespace-pre-line text-gray-700">
                {section.content}
              </p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
      <CartModal />
    </>
  );
};

export default Politica;